// extracted by mini-css-extract-plugin
module.exports = {"container":"NoContent_container__Y8vXK","sending":"NoContent_sending__25nx9"};